import React from 'react';
import { toLinearGradient } from 'theme/tokens';
import './GradientBorder.css';

interface GradientBorderProps {
  /** Gradient stop colors (2+). Defaults to the cyan→green brand border. */
  colors?: readonly string[];
  /** Outer corner radius in px. */
  borderRadius?: number;
  /** Border thickness in px (the gradient padding). */
  borderWidth?: number;
  /** Gradient angle, e.g. "135deg". */
  angle?: string;
  className?: string;
  innerClassName?: string;
  style?: React.CSSProperties;
  innerStyle?: React.CSSProperties;
  children?: React.ReactNode;
}

/**
 * Web equivalent of the mobile GradientBorder: a gradient-filled wrapper whose
 * padding forms the visible border, with a solid inner surface clipped to a
 * slightly smaller radius. Mirrors the .gb-wrap / .gb-inner design pattern.
 */
export function GradientBorder({
  colors = ['#00BFFF', '#00E87A'],
  borderRadius = 10,
  borderWidth = 2,
  angle = '135deg',
  className,
  innerClassName,
  style,
  innerStyle,
  children,
}: GradientBorderProps) {
  return (
    <div
      className={`gb-wrap${className ? ` ${className}` : ''}`}
      style={{
        padding: borderWidth,
        borderRadius,
        background: toLinearGradient(colors, angle),
        ...style,
      }}
    >
      <div
        className={`gb-inner${innerClassName ? ` ${innerClassName}` : ''}`}
        style={{ borderRadius: Math.max(0, borderRadius - borderWidth), ...innerStyle }}
      >
        {children}
      </div>
    </div>
  );
}
